import { Button, Typography } from '@mui/material';
import { Link } from "react-router-dom";
import { requestoauthApi } from "../services/authApi"
import { useState, useEffect } from "react";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import DoneIcon from '@mui/icons-material/Done';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormControl from '@mui/material/FormControl';
import SaveIcon from '@mui/icons-material/Save';
import { getregistertokenApi, setReferralCodeApi } from "../services/authApi"
import { customToastify, checkErrorMessage, checkResponseData } from "../components/pages/utils/utilsFunctions"
import { ToastContainer, toast } from "react-toastify";
import { setPasswordApi } from "../services/authApi"
import CircularProgress from '@mui/material/CircularProgress';

const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "95%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));


const AfterGoogleLogIn = ({ rtoken, handleResult }) => {

  const getRefreshToken = async () => {
    try {
      let response = await getregistertokenApi({ rtoken })
      console.log("getRefreshToken", response["data"])
      if (response["data"]["success"]) {
        localStorage.setItem("token", JSON.stringify(response.data.token));
        localStorage.setItem("refreshToken", JSON.stringify(response.data.refreshToken));
        const registerCode = JSON.parse(localStorage.getItem("registerCode"));
        if (registerCode) await setReferralCodeApi({ registerCode })
        handleResult("logedinuser")
      }
      window.location.href = "/googlelogIn";
    } catch (error) {
      window.location.href = "/googlelogIn";
    }
  }

  useEffect(() => {
    getRefreshToken();
  }, []);

  return (
    <>
      <Box sx={{ textAlign: "center", width: "95%" }}>
        <CircularProgress size={100} />
        <Typography variant="h4" style={{ color: 'white' }}>
          درحال دریافت اطلاعات
        </Typography>
        <Typography variant="h6" style={{ color: 'white' }}>
          لطفا صبر کنید ...
        </Typography>
      </Box>

    </>
  )
}


export default AfterGoogleLogIn;
